import useDataLayer from '@/hooks/useDataLayer/useDataLayer';
import Link from '@uikit/components/Link/Link';
import { useId } from 'react';
import styles from './AppStoreBadge.module.scss';

type StoreButtonProps = {
  clickContext: string;
};

export const AppleAppStoreButton = ({ clickContext }: StoreButtonProps) => {
  const { pushDataLayerEvent } = useDataLayer();

  return (
    <Link
      to="https://itunes.apple.com/de/app/id6451111737?mt=8"
      target="_blank"
      rel="noreferrer"
      aria-label="Im Apple App Store herunterladen"
      onClick={() => {
        pushDataLayerEvent({
          event: 'customClick',
          clickContext,
          customClickText: 'AppleAppStoreButton',
          customPagePath: window.location.pathname,
        });
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 119.664 40"
        style={{ aspectRatio: '119.664/40' }}
        className={styles.base}
      >
        <path
          fill="#a6a6a6"
          d="M110.135 0H9.535c-.367 0-.73 0-1.095.002-.306.002-.61.008-.919.013A13.215 13.215 0 005.517.19a6.665 6.665 0 00-1.9.627 6.438 6.438 0 00-1.62 1.18A6.258 6.258 0 00.82 3.617 6.601 6.601 0 00.195 5.52a12.993 12.993 0 00-.179 2.002c-.01.307-.01.615-.015.921V31.56c.005.31.006.61.015.921a12.992 12.992 0 00.18 2.002 6.588 6.588 0 00.624 1.905A6.208 6.208 0 001.998 38a6.274 6.274 0 001.618 1.179 6.7 6.7 0 001.901.63 13.455 13.455 0 002.004.177c.31.007.613.011.919.011.366.002.728.002 1.095.002h100.6c.36 0 .724 0 1.084-.002.304 0 .617-.004.922-.01a13.279 13.279 0 002-.178 6.804 6.804 0 001.908-.63A6.277 6.277 0 00117.666 38a6.395 6.395 0 001.182-1.614 6.604 6.604 0 00.619-1.905 13.506 13.506 0 00.185-2.002c.004-.31.004-.61.004-.921.008-.364.008-.725.008-1.094V9.536c0-.366 0-.73-.008-1.092 0-.306 0-.614-.004-.92a13.507 13.507 0 00-.185-2.003 6.618 6.618 0 00-.62-1.903 6.466 6.466 0 00-2.798-2.8 6.768 6.768 0 00-1.908-.627 13.044 13.044 0 00-2-.176c-.305-.005-.618-.011-.922-.013-.36-.002-.725-.002-1.084-.002z"
        />
        <path d="M8.445 39.125c-.305 0-.602-.004-.904-.01a12.687 12.687 0 01-1.87-.164 5.884 5.884 0 01-1.656-.548 5.406 5.406 0 01-1.397-1.016 5.32 5.32 0 01-1.02-1.397 5.722 5.722 0 01-.544-1.657 12.414 12.414 0 01-.166-1.875c-.007-.21-.015-.913-.015-.913v-23.1s.009-.692.015-.895a12.37 12.37 0 01.165-1.872 5.755 5.755 0 01.544-1.662 5.373 5.373 0 011.015-1.398 5.565 5.565 0 011.402-1.023 5.823 5.823 0 011.653-.544A12.586 12.586 0 017.543.887l.902-.012h102.769l.913.013a12.385 12.385 0 011.858.162 5.938 5.938 0 011.671.548 5.594 5.594 0 012.415 2.42 5.763 5.763 0 01.535 1.649 12.995 12.995 0 01.174 1.887c.003.283.003.588.003.89.008.375.008.732.008 1.092v20.929c0 .363 0 .718-.008 1.075 0 .325 0 .623-.004.93a12.731 12.731 0 01-.17 1.853 5.739 5.739 0 01-.54 1.67 5.48 5.48 0 01-1.016 1.386 5.413 5.413 0 01-1.4 1.022 5.862 5.862 0 01-1.668.55 12.542 12.542 0 01-1.869.163c-.293.007-.6.011-.897.011l-1.084.002z" />
        <g fill="#fff" data-name="&lt;Group&gt;">
          <g data-name="&lt;Group&gt;">
            <path
              d="M24.769 20.3a4.949 4.949 0 012.356-4.151 5.066 5.066 0 00-3.99-2.158c-1.68-.176-3.308 1.005-4.164 1.005-.872 0-2.19-.988-3.608-.958a5.315 5.315 0 00-4.473 2.728c-1.934 3.348-.491 8.269 1.361 10.976.927 1.325 2.01 2.805 3.428 2.753 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.852 1.489-.025 2.426-1.332 3.32-2.67a10.962 10.962 0 001.52-3.092 4.782 4.782 0 01-2.92-4.4zm-2.732-8.09a4.872 4.872 0 001.115-3.49 4.957 4.957 0 00-3.208 1.66 4.636 4.636 0 00-1.144 3.36 4.1 4.1 0 003.237-1.53z"
              data-name="&lt;Path&gt;"
            />
          </g>
          <path d="M42.302 27.14H37.57l-1.137 3.356h-2.005l4.484-12.418h2.083l4.483 12.418h-2.039zm-4.243-1.55h3.752l-1.85-5.446h-.051zm17.101.38c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 01-2.848-1.583h-.043v4.484h-1.86V21.442h1.8v1.506h.033a3.212 3.212 0 012.883-1.6c2.298 0 3.813 1.816 3.813 4.622zm-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.393-1.197 2.393-3.046zm11.875 0c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 01-2.848-1.583h-.043v4.484h-1.859V21.442h1.799v1.506h.034a3.212 3.212 0 012.883-1.6c2.298 0 3.813 1.816 3.813 4.622zm-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.392-1.197 2.392-3.046zm8.495 1.066c.138 1.232 1.334 2.04 2.97 2.04 1.566 0 2.693-.808 2.693-1.919 0-.964-.68-1.54-2.29-1.936l-1.609-.388c-2.28-.55-3.339-1.617-3.339-3.348 0-2.142 1.867-3.614 4.519-3.614 2.624 0 4.423 1.472 4.483 3.614h-1.876c-.112-1.239-1.136-1.987-2.634-1.987s-2.521.757-2.521 1.858c0 .878.654 1.395 2.255 1.79l1.368.336c2.548.603 3.606 1.626 3.606 3.443 0 2.323-1.85 3.778-4.793 3.778-2.754 0-4.614-1.42-4.734-3.667zM83.346 19.3v2.142h1.722v1.472h-1.722v4.991c0 .776.345 1.137 1.102 1.137a5.808 5.808 0 00.611-.043v1.463a5.104 5.104 0 01-1.032.086c-1.833 0-2.548-.689-2.548-2.445v-5.189h-1.316v-1.472h1.316V19.3zm2.719 6.67c0-2.849 1.678-4.639 4.294-4.639 2.625 0 4.295 1.79 4.295 4.639 0 2.856-1.661 4.638-4.295 4.638-2.633 0-4.294-1.782-4.294-4.638zm6.695 0c0-1.954-.895-3.108-2.401-3.108s-2.4 1.162-2.4 3.108c0 1.962.894 3.106 2.4 3.106s2.401-1.144 2.401-3.106zm3.426-4.528h1.773v1.541h.043a2.16 2.16 0 012.177-1.635 2.866 2.866 0 01.637.069v1.738a2.598 2.598 0 00-.835-.112 1.873 1.873 0 00-1.937 2.083v5.37h-1.858zm13.198 6.395c-.25 1.643-1.85 2.771-3.898 2.771-2.634 0-4.269-1.764-4.269-4.595 0-2.84 1.644-4.682 4.19-4.682 2.506 0 4.08 1.72 4.08 4.466v.637h-6.394v.112a2.358 2.358 0 002.436 2.564 2.048 2.048 0 002.09-1.273zm-6.282-2.702h4.526a2.177 2.177 0 00-2.22-2.298 2.292 2.292 0 00-2.306 2.298z" />
        </g>
        <path
          fill="#fff"
          d="M39.393 14.698H35.67V8.73h.927v5.115h2.795zm.937-1.274c0-.81.603-1.278 1.674-1.344l1.22-.07v-.389c0-.475-.315-.744-.922-.744-.496 0-.84.182-.939.5h-.86c.09-.773.818-1.27 1.84-1.27 1.129 0 1.765.563 1.765 1.514v3.077h-.855v-.633h-.07a1.515 1.515 0 01-1.353.707 1.36 1.36 0 01-1.5-1.348zm2.894-.384v-.377l-1.1.07c-.62.042-.901.253-.901.65 0 .405.351.64.835.64a1.062 1.062 0 001.166-.983zm2.052-.596c0-1.423.732-2.324 1.87-2.324a1.484 1.484 0 011.38.79h.067V8.437h.888v6.26h-.851v-.71h-.07a1.563 1.563 0 01-1.414.785c-1.146 0-1.87-.901-1.87-2.328zm.918 0c0 .955.45 1.53 1.204 1.53.749 0 1.211-.583 1.211-1.526 0-.938-.467-1.53-1.211-1.53-.749 0-1.204.58-1.204 1.526zm8.553 1.038a1.828 1.828 0 01-1.951 1.303 2.045 2.045 0 01-2.08-2.325 2.077 2.077 0 012.076-2.352c1.253 0 2.009.856 2.009 2.27v.31h-3.18v.05a1.19 1.19 0 001.2 1.29 1.08 1.08 0 001.07-.546zm-3.126-1.451h2.275a1.086 1.086 0 00-1.109-1.167 1.152 1.152 0 00-1.166 1.167zm4.373-1.836h.856v.715h.066a1.348 1.348 0 011.344-.802 1.465 1.465 0 011.558 1.675v2.915h-.888v-2.692c0-.724-.315-1.084-.972-1.084a1.033 1.033 0 00-1.075 1.141v2.635h-.889zm7.526-1.332a.576.576 0 11.575.542.547.547 0 01-.575-.542zm.132 1.332h.885v4.503h-.885zm2.319 0h.856v.723h.066a1.364 1.364 0 012.493 0h.07a1.463 1.463 0 011.37-.81 1.338 1.338 0 011.438 1.488v3.102h-.888v-2.87c0-.608-.29-.906-.873-.906a.912.912 0 00-.95.943v2.833h-.874V11.74a.785.785 0 00-.868-.819.969.969 0 00-.951 1.022v2.754h-.889z"
          data-name="&lt;Group&gt;"
        />
      </svg>
    </Link>
  );
};

export const GooglePlayStoreButton = ({ clickContext }: StoreButtonProps) => {
  const id = useId();
  const { pushDataLayerEvent } = useDataLayer();

  return (
    <a
      href="https://play.google.com/store/apps/details?id=de.enercity.charging"
      target="_blank"
      rel="noreferrer"
      aria-label="Im Google Play Store herunterladen"
      onClick={() => {
        pushDataLayerEvent({
          event: 'customClick',
          clickContext,
          customClickText: 'GooglePlayStoreButton',
          customPagePath: window.location.pathname,
        });
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 190 56"
        style={{ aspectRatio: '190/56' }}
        className={styles.base}
      >
        <mask
          id={`${id}-a`}
          style={{ maskType: 'luminance' }}
          width="190"
          height="56"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
        </mask>
        <g mask={`url(#${id}-a)`}>
          <mask
            id={`${id}-b`}
            style={{ maskType: 'luminance' }}
            width="190"
            height="56"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
          </mask>
          <g mask={`url(#${id}-b)`}>
            <path
              fill="#010201"
              d="M182.508 56H7.492C3.66 56 .5 52.84.5 49.007V6.993C.5 3.13 3.66 0 7.492 0h174.986c3.862 0 6.993 3.16 6.993 6.993v42.014C189.5 52.84 186.34 56 182.508 56z"
            />
          </g>
          <mask
            id={`${id}-c`}
            style={{ maskType: 'luminance' }}
            width="190"
            height="56"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
          </mask>
          <g mask={`url(#${id}-c)`}>
            <path
              fill="#9C9B9B"
              d="M182.508 1.112a5.88 5.88 0 015.88 5.88v42.015a5.88 5.88 0 01-5.88 5.881H7.492a5.881 5.881 0 01-5.88-5.88V6.992a5.881 5.881 0 015.88-5.881h175.016zm0-1.112H7.492C3.66 0 .5 3.16.5 6.993v42.014C.5 52.87 3.66 56 7.492 56h174.986c3.862 0 6.993-3.16 6.993-6.993V6.993C189.5 3.16 186.34 0 182.508 0z"
            />
          </g>
          <mask
            id={`${id}-d`}
            style={{ maskType: 'luminance' }}
            width="190"
            height="56"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
          </mask>
          <g mask={`url(#${id}-d)`}>
            <path
              fill="#fff"
              d="M95.878 30.458c-3.306 0-5.969 2.516-5.969 5.969 0 3.423 2.692 5.968 5.969 5.968 3.306 0 5.968-2.516 5.968-5.968.03-3.482-2.662-5.969-5.968-5.969zm0 9.567c-1.814 0-3.365-1.492-3.365-3.598 0-2.136 1.551-3.6 3.365-3.6 1.814 0 3.365 1.464 3.365 3.6 0 2.106-1.551 3.598-3.365 3.598zm-13.02-9.567c-3.305 0-5.968 2.516-5.968 5.969 0 3.423 2.692 5.968 5.969 5.968 3.306 0 5.968-2.516 5.968-5.968 0-3.482-2.692-5.969-5.968-5.969zm0 9.567c-1.813 0-3.364-1.492-3.364-3.598 0-2.136 1.55-3.6 3.365-3.6 1.814 0 3.364 1.464 3.364 3.6 0 2.106-1.58 3.598-3.364 3.598zm-15.506-7.753v2.516h6.057c-.176 1.434-.644 2.458-1.376 3.19-.877.877-2.252 1.843-4.68 1.843-3.716 0-6.642-2.985-6.642-6.73 0-3.716 2.897-6.73 6.641-6.73 2.02 0 3.482.79 4.564 1.815l1.785-1.785c-1.521-1.433-3.51-2.545-6.349-2.545-5.09 0-9.391 4.154-9.391 9.245 0 5.091 4.272 9.246 9.391 9.246 2.75 0 4.828-.907 6.437-2.604 1.668-1.668 2.194-4.008 2.194-5.91a8.3 8.3 0 00-.146-1.58h-8.485v.029zm63.43 1.96c-.498-1.346-2.019-3.803-5.091-3.803s-5.618 2.399-5.618 5.968c0 3.336 2.517 5.97 5.91 5.97 2.721 0 4.301-1.669 4.974-2.634l-2.019-1.346c-.673.995-1.609 1.638-2.925 1.638-1.317 0-2.282-.614-2.897-1.814l7.958-3.306-.292-.673zm-8.134 1.99c-.058-2.312 1.785-3.482 3.101-3.482 1.054 0 1.931.527 2.224 1.258l-5.325 2.224zm-6.466 5.793h2.604V24.489h-2.604v17.526zm-4.3-10.24h-.088c-.585-.702-1.726-1.346-3.131-1.346-2.984 0-5.705 2.604-5.705 5.968 0 3.336 2.721 5.94 5.705 5.94 1.434 0 2.546-.644 3.131-1.346h.088v.848c0 2.283-1.229 3.482-3.189 3.482-1.61 0-2.604-1.14-3.014-2.106l-2.282.936c.644 1.58 2.399 3.51 5.266 3.51 3.072 0 5.676-1.813 5.676-6.202V30.78h-2.487v.996h.03zm-2.985 8.25c-1.814 0-3.306-1.521-3.306-3.598 0-2.107 1.522-3.628 3.306-3.628 1.785 0 3.189 1.521 3.189 3.628 0 2.077-1.404 3.598-3.189 3.598zM143.04 24.49h-6.261v17.497h2.604v-6.642h3.657c2.897 0 5.735-2.106 5.735-5.442 0-3.306-2.838-5.413-5.735-5.413zm.059 8.456h-3.716v-5.998h3.716c1.96 0 3.072 1.61 3.072 3.014 0 1.316-1.112 2.984-3.072 2.984zm16.15-2.516c-1.902 0-3.862.819-4.652 2.692l2.311.965c.497-.965 1.404-1.287 2.399-1.287 1.346 0 2.721.819 2.75 2.253v.175c-.468-.263-1.492-.673-2.721-.673-2.487 0-5.032 1.375-5.032 3.95 0 2.34 2.048 3.862 4.359 3.862 1.756 0 2.721-.79 3.336-1.697h.087v1.346h2.517v-6.7c-.059-3.16-2.37-4.886-5.354-4.886zm-.322 9.596c-.849 0-2.048-.438-2.048-1.492 0-1.346 1.492-1.872 2.779-1.872 1.141 0 1.697.234 2.399.585-.234 1.61-1.609 2.78-3.13 2.78zm14.804-9.216l-2.984 7.578h-.088l-3.101-7.578h-2.809l4.652 10.592-2.663 5.91h2.721l7.197-16.502h-2.925zm-23.523 11.206h2.604V24.489h-2.604v17.526z"
            />
          </g>
          <mask
            id={`${id}-e`}
            style={{ maskType: 'luminance' }}
            width="190"
            height="56"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
          </mask>
          <g mask={`url(#${id}-e)`}>
            <path
              fill="#E63B2E"
              d="M29.493 27.18L14.602 43.01a4.02 4.02 0 003.89 2.984c.732 0 1.434-.205 2.049-.556l.058-.03 16.765-9.684-7.87-8.543z"
            />
          </g>
          <mask
            id={`${id}-f`}
            style={{ maskType: 'luminance' }}
            width="190"
            height="56"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
          </mask>
          <g mask={`url(#${id}-f)`}>
            <path
              fill="#F8B315"
              d="M44.59 24.489l-7.255-4.214-8.163 7.286 8.192 8.192 7.197-4.155a4.017 4.017 0 002.106-3.54 4.04 4.04 0 00-2.077-3.57z"
            />
          </g>
          <mask
            id="g"
            style={{ maskType: 'luminance' }}
            width="190"
            height="56"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
          </mask>
          <g mask="url(#g)">
            <path
              fill="#4A72B7"
              d="M14.601 12.99a3.935 3.935 0 00-.146 1.024v27.971c0 .351.059.702.146 1.024L30.02 27.59 14.6 12.99z"
            />
          </g>
          <mask
            id={`${id}-h`}
            style={{ maskType: 'luminance' }}
            width="190"
            height="56"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
          </mask>
          <g mask={`url(#${id}-h)`}>
            <path
              fill="#2D9E48"
              d="M29.61 28l7.724-7.725-16.764-9.713c-.614-.351-1.317-.585-2.077-.585a4.02 4.02 0 00-3.891 2.984L29.61 28z"
            />
          </g>
        </g>
        <mask
          id={`${id}-i`}
          style={{ maskType: 'luminance' }}
          width="190"
          height="56"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M189.5 0H.5v56h189V0z" />
        </mask>
        <g fill="#fff" mask={`url(#${id}-i)`}>
          <path d="M59.366 18.052c-.498-.35-.849-.877-1.053-1.521l1.228-.497c.117.438.322.79.585.994.264.205.586.322.937.322.438 0 .76-.146 1.024-.439.263-.292.38-.673.38-1.17V9.655h1.346v5.998c0 .615-.117 1.141-.351 1.58-.234.439-.556.76-.966.995a2.78 2.78 0 01-1.404.351 2.939 2.939 0 01-1.726-.527zm6.612-8.397h5.296v1.258h-3.95v2.458h3.57v1.258h-3.57v2.458h3.95v1.258h-5.296v-8.69zm8.952 1.288h-2.457V9.685h6.231v1.258h-2.428v7.46H74.93v-7.46zm4.798 6.085l4.565-6.085h-4.36V9.685h5.91v1.345l-4.535 6.086h4.594v1.258h-6.174v-1.346zm9.743-6.085h-2.457V9.685h6.231v1.258h-2.428v7.46h-1.346v-7.46zM97.4 9.655h3.277c.468 0 .907.088 1.287.293.41.205.703.468.937.848.234.351.351.732.351 1.17 0 .44-.117.82-.322 1.142-.205.322-.497.556-.848.731v.059a2.095 2.095 0 011.492 2.018c0 .469-.117.907-.381 1.288-.234.38-.585.643-.994.878-.41.204-.878.321-1.376.321H97.4V9.655zm3.219 3.687c.409 0 .731-.117.965-.38.234-.235.351-.527.351-.849a1.17 1.17 0 00-.351-.848c-.234-.235-.556-.352-.936-.352h-1.902v2.429h1.873zm.204 3.803c.41 0 .761-.117 1.024-.38.264-.263.381-.556.381-.907s-.147-.673-.41-.936c-.263-.264-.614-.38-1.053-.38h-2.019v2.633h2.077v-.03zm4.505-7.49h5.296v1.258h-3.95v2.458h3.54v1.258h-3.569v2.458h3.949v1.258h-5.295v-8.69h.029zm7.168 0h1.346v8.72h-1.346v-8.72z" />
        </g>
      </svg>
    </a>
  );
};
